import React, { Component } from 'react';

export default class ModalFooter extends Component<{ children?: React.ReactNode }, {}> {
  state = {};

  render() {
    return <div className="bg-white modal-footer d-flex flex-column px-8 py-8">{this.props.children}</div>;
  }
}
